import EventTracker from "./EventTracker";

export default EventTracker;
